import { computed, type Ref } from "vue";
import { useStaticImage } from "./useStaticImage";

export function useImage(image: Ref<string | undefined>) {
  const { imageUrl: staticUrl } = useStaticImage(image);
  const imageUrl = computed(() => {
    if (
      image.value?.indexOf("http://") === 0 ||
      image.value?.indexOf("https://") === 0
    ) {
      return image.value;
    }

    return staticUrl.value;
  });

  return { imageUrl };
}
